import { z } from "zod";

export const publicMeetingResponseSchema = z.object({
	id: z.uuid(),
	title: z.string(),
	description: z.string().nullable(),
	cover_image: z.string().nullable(),
	format: z.string(),
	start_at: z.string(),
	end_at: z.string(),
	address: z.string().nullable(),
	latitude: z.string().nullable(),
	longitude: z.string().nullable(),
	max_capacity: z.number().nullable(),
	community_name: z.string(),
	community_logo_url: z.string().nullable(),
	host_first_name: z.string().nullable(),
	host_last_name: z.string().nullable(),
	host_photo_url: z.string().nullable(),
});

export type PublicMeetingResponse = z.infer<typeof publicMeetingResponseSchema>;
